import FeaturedCard from "./FeaturedCard";
import { apiUrl } from "@/constants";
import { Songcard } from "@/types";
import { Center, Container, SimpleGrid, Text } from "@chakra-ui/react";
import { useInView } from "framer-motion";
import { useCallback, useEffect, useRef, useState } from "react";

export default function FeaturedCards() {
  const [data, setData] = useState<Songcard[]>([]);
  const [loadingMore, setLoadingMore] = useState<boolean>(false);
  const [loadingCards, setLoadingCards] = useState(true);
  const ref = useRef(null);
  const isInView = useInView(ref);

  const fetchData = async () => {
    try {
      const response = await fetch(`${apiUrl}/ninja/featured-cards`);
      const featuredCards: Songcard[] = await response.json();
      setData(featuredCards);
      setLoadingCards(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchMore = useCallback(async () => {
    setLoadingMore(true);
    try {
      const response = await fetch(`${apiUrl}/ninja/featured-cards`);
      const moreFeaturedCards = await response.json();
      setData((prevData) => [...prevData, ...moreFeaturedCards]);
      setLoadingMore(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoadingMore(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchMore();
  }, [fetchMore, isInView]);

  return (
    <div>
      {!loadingCards && (
        <SimpleGrid columns={[1, null, 2]} spacing="25px">
          {data.map((card, index) => (
            <FeaturedCard card={card} key={index} embed={false} />
          ))}
          <br></br>
        </SimpleGrid>
      )}
      <Container mt={50}>
        <div ref={ref}>
          {!loadingMore && (
            <Center>
              <button onClick={fetchMore}>load more</button>
            </Center>
          )}
        </div>
        {loadingMore && (
          <Center>
            <Text>loading cards...</Text>
          </Center>
        )}
      </Container>
    </div>
  );
}
